import { useCallback, useEffect, useState } from "react";
import { Explain } from "@/components/area/Explain";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { errMsg, formatDate, useApi } from "@/lib/api";
import { PlanEditor } from "./PlanEditor";

const ST = { active: "Attivo", trial: "In prova", paused: "In pausa" };

// Plan assigned by ADM: features, limits and REAL usage. No prices, invoices or credits here (wallet not active).
export default function AreaPlan({ tid, role }) {
  const api = useApi();
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get(`/t/${tid}/plan`).then(({ data }) => setD(data)).catch((e) => toast.error(errMsg(e))), [api, tid]);
  useEffect(() => { load(); }, [load]);
  if (!d) return <Loader2 className="animate-spin text-slate-400" />;
  const p = d.plan;
  return (
    <div className="space-y-3" data-testid="area-plan">
      <section className="rounded-lg border border-slate-200 bg-white p-4">
        {p ? <><p className="text-xs uppercase tracking-wide text-slate-500">{role === "support" ? "Piano del cliente" : "Il tuo piano"}</p>
          <p className="text-xl font-semibold text-slate-900" data-testid="plan-name">{p.name} <span className="text-xs font-normal text-slate-500">· {ST[p.status]}</span></p>
          {p.note && <p className="mt-1 text-xs text-slate-600">{p.note}</p>}
          <div className="mt-2 flex flex-wrap gap-1.5" data-testid="plan-features">{p.features.map((f) => <span key={f.key} className="rounded bg-sky-50 px-2 py-0.5 text-[11px] text-sky-800">{f.label}</span>)}</div>
          <p className="mt-2 text-[11px] text-slate-500">Le funzioni elencate descrivono il piano concordato con MUSORA; per ora non bloccano le sezioni dell'area.</p></>
          : <p className="text-sm text-slate-600" data-testid="plan-none">MUSORA non ha ancora assegnato un piano a questo spazio. Qui sotto vedi comunque l'utilizzo reale.</p>}
      </section>
      <section className="rounded-lg border border-slate-200 bg-white p-4" data-testid="plan-usage">
        <p className="mb-2 text-sm font-medium text-slate-800">Utilizzo</p>
        <ul className="grid gap-2 sm:grid-cols-2">{Object.entries(d.limit_labels).map(([k, l]) => {
          const lim = p?.limits?.[k]; const over = d.over.includes(k);
          return <li key={k} className={`flex justify-between rounded px-3 py-2 text-xs ${over ? "bg-red-50 text-red-800" : "bg-slate-50 text-slate-700"}`} data-testid={`plan-usage-${k}`}>
            <span>{l}</span><b>{d.usage[k]}{lim === undefined || lim === null ? "" : ` / ${lim}`}{over ? " · oltre il limite" : ""}</b></li>; })}</ul>
        <p className="mt-2 text-[11px] text-slate-500">Email del mese: preparate {d.usage.emails_month}, inviate davvero {d.usage.emails_month_sent}.</p>
      </section>
      <p className="rounded-md border border-sky-200 bg-sky-50 px-3 py-2 text-xs text-sky-900" data-testid="plan-email">{d.email.tool}: {d.email.note}</p>
      <Explain title="Crediti e consumi" testid="plan-explain"><p data-testid="plan-wallet">{d.wallet.note}</p></Explain>
      {p?.updated_at && <p className="text-[11px] text-slate-400">Piano aggiornato il {formatDate(p.updated_at, true)}</p>}
      {d.can_edit && <PlanEditor tid={tid} d={d} onSaved={load} />}
    </div>);
}
